module.exports = __webpack_public_path__ + "media/npc_dota_hero_naga_siren.ea7daa1f.webm";